'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendBeacon = exports.generateProfileEvents = exports.formatProfileEvents = undefined;

var _deepAssign3 = require('deep-assign');

var _deepAssign4 = _interopRequireDefault(_deepAssign3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-console */

/**
 * Format profile event objects into an array of profile event strings.
 *
 * Example profile event object:
 *
 *      aaa: {
 *          thresholds: {
 *              delighted: '100',
 *              satisfied: '200'
 *          },
 *          timestamp: '111'
 *      }
 *
 * Example formatted event string:
 *
 *      '111 aaa,100 delighted,200 satisfied'
 *
 * The first timestamp/name pair will always be the profile event, followed by the event's
 * thresholds, sorted by timestamp, ascending.
 *
 * @param {object} profileEvents - profile event objects
 */
var formatProfileEvents = exports.formatProfileEvents = function formatProfileEvents() {
    var profileEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(profileEvents).map(function (profileEventName) {
        return (
            // the first element is always the event pair...
            [profileEvents[profileEventName].timestamp + ' ' + profileEventName]

            // followed by its threshold pairs
            .concat(Object.keys(profileEvents[profileEventName].thresholds).map(function (thresholdName) {
                return profileEvents[profileEventName].thresholds[thresholdName] + ' ' + thresholdName;
            })

            // sort thresholds by time to make the order deterministic
            .sort())

            // finally, join all fields with a ','
            .join(',')
        );
    });
};

/**
 * Generate profile event objects from an array of profile event strings.
 *
 * Example profile events string, where '111' is the timestamp, and 'a a a' is the event name:
 *
 *      '111 a a a'
 *
 * Example profile event object, where 'aaa' is the translated event name from eventNameMap, and
 * 'thresholds' are populated from eventThresholds:
 *
 *      aaa: {
 *          thresholds: {
 *              delighted: '100',
 *              satisfied: '200'
 *          },
 *          timestamp: '111'
 *      }
 *
 * @param {*} profiles
 * @param {*} eventNameMap
 * @param {*} eventThresholds
 */
var generateProfileEvents = exports.generateProfileEvents = function generateProfileEvents() {
    var profiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var eventNameMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var eventThresholds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return profiles.reduce(function (accu, profile) {
        var splitProfile = profile.split(' ');
        var eventTimestamp = splitProfile[0];
        var humanEventName = splitProfile.slice(1).join(' ');

        // either get the machine event name from the event name map, or replace all non-
        // alphanumeric characters with underscore if the name not found in the event name map
        var machineEventName = eventNameMap[humanEventName] || humanEventName.replace(/\W/g, '_');

        return (0, _deepAssign4.default)({}, accu, _defineProperty({}, machineEventName, {
            thresholds: (0, _deepAssign4.default)({}, eventThresholds[machineEventName]),
            timestamp: eventTimestamp
        }));
    }, {});
};

/**
 * Beacons the specified data to the specified endpoint.
 *
 * @param {*} opts
 * @param {*} formatProfileEvents
 * @param {*} generateProfileEvents
 */
var sendBeacon = exports.sendBeacon = function sendBeacon(opts) {
    var formatProfileEventsFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatProfileEvents;
    var generateProfileEventsFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : generateProfileEvents;

    var defaultOpts = {
        eventNameMap: {},
        eventThresholds: {},
        profiles: [],
        staticBeaconData: {}
    };

    var _deepAssign2 = (0, _deepAssign4.default)({}, defaultOpts, opts),
        beaconUrl = _deepAssign2.beaconUrl,
        eventNameMap = _deepAssign2.eventNameMap,
        eventThresholds = _deepAssign2.eventThresholds,
        profiles = _deepAssign2.profiles,
        staticBeaconData = _deepAssign2.staticBeaconData;

    if (typeof beaconUrl !== 'string') {
        console.error('the beacon URL must be a string');
        return;
    }

    // construct the beacon data, beginning with the static data, and adding the formatted events
    var beaconData = (0, _deepAssign4.default)({}, staticBeaconData, {
        events: formatProfileEventsFn(generateProfileEventsFn(profiles, eventNameMap, eventThresholds))
    });

    // fire the beacon, log an error if it wasn't sucessful
    if (!global.navigator.sendBeacon(beaconUrl, JSON.stringify(beaconData))) {
        console.error('beacon failure! URL:', beaconUrl, 'data:', beaconData);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/sendBeacon.js
// module id = 497
// module chunks = 4